import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { SiteProvider } from './context/SiteContext';
import { AuthProvider } from './context/AuthContext';
import { FilterProvider } from './context/FilterContext';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Onboard from './pages/Onboard';
import useSecurityShield from './hooks/useSecurityShield';

function App() {
  useSecurityShield();
  return (
    <div className="App">
      <SiteProvider>
        <AuthProvider>
          <FilterProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/onboard/:token" element={<Onboard />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
          </FilterProvider>
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
